import { RATE_STEPS, MAX_RATE, MIN_POSITIVE_RATE, REVIEW_URL } from '../constants';

import html from './rateModal.html';

class RateModalCtrl {
  constructor(RateService) {
    'ngInject';

    Object.assign(this, { RateService });
  }

  $onInit() {
    this.stepNumber = 0;
    this.rating = 0;
    this.steps = RATE_STEPS;
    this.MAX_RATE = MAX_RATE;
    this.REVIEW_URL = REVIEW_URL;
  }

  get step() {
    return RATE_STEPS[this.stepNumber];
  }

  changeRating(rating) {
    this.rating = rating;

    if (rating >= MIN_POSITIVE_RATE) {
      this.stepNumber = 1;
    } else {
      this.stepNumber = 2;
    }
  }

  close() {
    this.RateService.closeRateModal(this.rating);
  }

  isLastStep() {
    return this.stepNumber === 3;
  }

  showReview() {
    return this.stepNumber === 1;
  }

  showForm() {
    return this.stepNumber === 2;
  }

  submitReview() {
    this.close();
    this.RateService.saveAppReviewed();
  }

  submitFeedback() {
    this.RateService.submitFeedback({ message: this.message, rating: this.rating });
    this.stepNumber = 3;
  }
}

export default {
  controller: RateModalCtrl,
  controllerAs: 'ctrl',
  templateUrl: html,
};
